var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3642 16.8902C13.6137 19.6411 9.5408 20.2354 6.20777 18.694C5.71574 18.4959 5.31234 18.3357 4.92883 18.3357C3.86064 18.3421 2.53105 19.3778 1.84002 18.6876C1.149 17.9965 2.18554 16.6659 2.18554 15.5912C2.18554 15.2077 2.03177 14.8115 1.83369 14.3185C0.291548 10.986 0.886698 6.91176 3.63723 4.16183C7.14844 0.649333 12.853 0.649333 16.3642 4.16092C19.8818 7.67885 19.8754 13.3786 16.3642 16.8902Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5456 10.899H13.5537",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93716 10.899H9.94526",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32876 10.899H6.33686",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.9567ffba137e87734d886fac896640ae.svg";
export { ForwardRef as ReactComponent };